import * as THREE from "three";
import { GLTFLoader } from "three/examples/jsm/loaders/GLTFLoader.js";
import { DRACOLoader } from "three/examples/jsm/loaders/DRACOLoader.js";
import { MeshoptDecoder } from "three/examples/jsm/libs/meshopt_decoder.module.js";
import { OrbitControls } from "three/examples/jsm/controls/OrbitControls.js";
import { computeBoundsTree, disposeBoundsTree, acceleratedRaycast } from "three-mesh-bvh";

// Point d'entrée esbuild dédié (bundle-three-vendor.min.js), chargé en dépendance avant
// bundle-home/wave/solutions : une seule copie de Three.js partagée entre les 3 bundles 3D,
// au lieu que chacun embarque la sienne (poids multiplié + warning "Multiple instances of
// Three.js being imported"). Les scènes lisent THREE et ses loaders depuis window.ThreeVendor.
THREE.BufferGeometry.prototype.computeBoundsTree = computeBoundsTree;
THREE.BufferGeometry.prototype.disposeBoundsTree = disposeBoundsTree;
THREE.Mesh.prototype.raycast = acceleratedRaycast;

window.ThreeVendor = { THREE, GLTFLoader, DRACOLoader, MeshoptDecoder, OrbitControls };
